import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from '@react-pdf/renderer';

import SITLogo from '../../assets/images/sitlogo.png'

// Sample data
// const reportData = [
//   {
//     Course_Name: 'Piping Engineering',
//     Batch_code: '01159',
//     month: 'February',
//     Take_Dt: '2025-02-05',
//   },
//   {
//     Course_Name: 'Piping Engineering',
//     Batch_code: '01160',
//     month: 'May',
//     Take_Dt: '2025-05-13',
//   },
// ];



const styles = StyleSheet.create({
  page: { padding: 20, fontSize: 10, fontFamily: 'Helvetica' },
  header: { fontSize: 14, textAlign: 'center', marginBottom: 10, fontWeight: 'bold' },
  row: { flexDirection: 'row', borderBottom: 1 },
  cell: {
    padding: 5,
    border: 1,
    borderColor: '#000',
    textAlign: 'center',
  },
  cellHeader: {
    backgroundColor: '#eee',
    fontWeight: 'bold',
  },
  logo: {
    width: 60,
    height: 30,
    marginBottom: 5,
  },
  titleContainer: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 },
});

const Mock_Report = ({reportData}) => {

  const months = [...new Set(reportData.map((d) => d.month))];

const grouped = reportData.reduce((acc, cur) => {
  if (!acc[cur.Course_Name]) acc[cur.Course_Name] = {};
  if (!acc[cur.Course_Name][cur.Batch_code]) acc[cur.Course_Name][cur.Batch_code] = {};
  acc[cur.Course_Name][cur.Batch_code][cur.month] = cur.Take_Dt;
  return acc;
}, {});

  return (
    
  <Document>
    <Page size="A4" style={styles.page} >
      {/* Logo and Header */}
      <View style={styles.titleContainer}>
        <Image style={styles.logo} src={SITLogo} />
        <Text style={styles.header}>MOCK REPORT : 2024 To 2025</Text>
      </View>

      {/* Table Header */}
      <View style={styles.row}>
        <Text style={[styles.cell, styles.cellHeader, { width: '30%' }]}>Course</Text>
        <Text style={[styles.cell, styles.cellHeader, { width: '15%' }]}>Batch</Text>
        {months.map((month) => (
          <Text key={month} style={[styles.cell, styles.cellHeader,  { width: `${55 / months.length}%` }]}>
            {month}
          </Text>
        ))}
      </View>

      {/* Course & Batch Rows */}
      {Object.entries(grouped).map(([course, batches]) => {
        // Determine which months are covered
        const courseMonths = months.map((m) =>
          Object.values(batches).some((b) => b[m]) ? '✓' : ''
        );

        return (
          <React.Fragment key={course}>
            {/* Course Total Row */}
            <View style={styles.row}>
              <Text style={[styles.cell, { width: '30%' }]}>{course}</Text>
              <Text style={[styles.cell, { width: '15%' }]}>Total</Text>
              {months.map((val, idx) => (
                <Text key={idx} style={[styles.cell, { width: `${55 / months.length}%` }]}>
                  {val}
                </Text>
              ))}
            </View>

            {/* Batch Rows */}
            {Object.entries(batches).map(([batch, monthMap]) => (
              <View style={styles.row} key={batch}>
                <Text style={[styles.cell, { width: '30%' }]}></Text>
                <Text style={[styles.cell, { width: '15%' }]}>{batch}</Text>
                {months.map((month) => (
                  <Text key={month} style={[styles.cell, { width: `${55 / months.length}%` }]}>
                    {monthMap[month]
                      ? new Date(monthMap[month]).toLocaleDateString('en-GB')
                      : ''}
                  </Text>
                ))}
              </View>
            ))}
          </React.Fragment>

        );
      })}
    </Page>
  </Document>
  )
}




export default Mock_Report;
